/* ============================================================
   AURA6 LANDING PAGE — JAVASCRIPT
   ============================================================ */

document.addEventListener('DOMContentLoaded', function() {

  /* ---- Detect Shopify theme editor — skip all animations ---- */
  var inEditor = window.Shopify && window.Shopify.designMode;
  if (inEditor) {
    document.querySelectorAll('.a6-fade').forEach(function(el) {
      el.classList.add('visible');
    });
  }

  /* ---- Nav scroll effect ---- */
  var nav = document.getElementById('a6-nav');
  if (nav) {
    if (inEditor) {
      nav.classList.add('scrolled');
    }
    window.addEventListener('scroll', function() {
      nav.classList.toggle('scrolled', window.scrollY > 60);
    }, { passive: true });
  }

  /* ---- Intersection observer fades (live site only) ---- */
  if (!inEditor) {
    var fades = document.querySelectorAll('.a6-fade');
    if (fades.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          if (e.isIntersecting) {
            e.target.classList.add('visible');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.1 });
      fades.forEach(function(el) { io.observe(el); });
    } else {
      /* Fallback — no IntersectionObserver support */
      document.querySelectorAll('.a6-fade').forEach(function(el) {
        el.classList.add('visible');
      });
    }
  }

  /* ---- Smooth anchor links ---- */
  document.querySelectorAll('a[href^="#"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      var target = document.querySelector(a.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setTimeout(function() {
        var inp = target.querySelector('input[type="email"]');
        if (inp) inp.focus();
      }, 650);
    });
  });

  /* ---- iOS autoplay ---- */
  document.querySelectorAll('video').forEach(function(v) {
    v.muted = true;
    v.play().catch(function() {});
  });

  /* ---- Auto-scroll to success/error message after form submit ---- */
  var msg = document.querySelector('.a6-waitlist__success, .a6-waitlist__error');
  if (msg) {
    msg.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

});

/* ---- Re-run fades when editor updates a section ---- */
document.addEventListener('shopify:section:load', function() {
  document.querySelectorAll('.a6-fade').forEach(function(el) {
    el.classList.add('visible');
  });
  var nav = document.getElementById('a6-nav');
  if (nav) nav.classList.add('scrolled');
});

document.addEventListener('shopify:section:select', function() {
  document.querySelectorAll('.a6-fade').forEach(function(el) {
    el.classList.add('visible');
  });
});

/* ---- Contact modal ---- */
function a6OpenContact() {
  var modal = document.getElementById('a6-contact-modal');
  if (!modal) return;
  modal.classList.add('is-open');
  modal.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  setTimeout(function() {
    var first = modal.querySelector('input, textarea');
    if (first) first.focus();
  }, 280);
}

function a6CloseContact() {
  var modal = document.getElementById('a6-contact-modal');
  if (!modal) return;
  modal.classList.remove('is-open');
  modal.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

/* Close on Escape key */
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') { a6CloseContact(); a6CloseWaitlist(); }
});

/* ---- Waitlist success modal ---- */
function a6CloseWaitlist() {
  var modal = document.getElementById('a6-waitlist-success-modal');
  if (!modal) return;
  modal.classList.remove('is-open');
  modal.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

/* Auto-open on page load if form just posted successfully */
(function() {
  var modal = document.getElementById('a6-waitlist-success-modal');
  if (!modal || modal.getAttribute('data-auto-open') !== 'true') return;
  document.body.style.overflow = 'hidden';
  modal.classList.add('is-open');
  modal.setAttribute('aria-hidden', 'false');
})();

/* Auto-open modal if form was just submitted (success or errors — Shopify redirects back to same page) */
(function() {
  var modal = document.getElementById('a6-contact-modal');
  if (!modal) return;
  /* Shopify appends ?contact%5Bsubmitted%5D=1 or similar; detect success message or errors inside modal */
  var hasSuccess = modal.querySelector('.a6-modal__success');
  var hasErrors  = modal.querySelector('.a6-modal__errors');
  if (hasSuccess || hasErrors) {
    a6OpenContact();
  }
})();
